/**
 * @description auth 관련 브로드캐스트 채널 이름
 */
export const AUTH_CHANNEL_NAME = 'auth-sync' as const;

/**
 * @description auth 관련 브로드캐스트 채널 메시지 타입을 관리합니다.
 */
export const AUTH_CHANNEL_MESSAGE = {
  LOGIN: 'LOGIN',
} as const;

export type TypeAuthChannelMessage = (typeof AUTH_CHANNEL_MESSAGE)[keyof typeof AUTH_CHANNEL_MESSAGE];
